import { pipe } from 'ramda'
import { log } from './log'

export const reject = (e: Error) => {
  throw e
}

export const logAndReject = pipe(log, reject)

export const wait = (ms: number) =>
  new Promise<void>(resolve => setTimeout(() => resolve(), ms))
